function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, React.createElement("g", {
  className: "left-arrow",
  transform: "translate(-169.000000, -959.000000)",
  stroke: "#142428",
  strokeWidth: 2
}, React.createElement("g", {
  transform: "translate(170.000000, 960.000000)"
}, React.createElement("polyline", {
  transform: "translate(4.115407, 7.557703) scale(-1, 1) rotate(-90.000000) translate(-4.115407, -7.557703) ",
  points: "-3 4 4.115407 11.115407 11.230814 4"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "10px",
    height: "17px",
    viewBox: "0 0 10 17",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ico_arrow_slide_left.76c801e3.svg";
export { SvgComponent as ReactComponent };